import dayjs from "dayjs";
/** `+79990002222` → `+7 999 000-22-22`; иное — как есть. */
export const formatPhoneE164 = (phone) => {
    if (!phone)
        return "—";
    const digits = phone.replace(/\D/g, "");
    if (digits.length === 11 && digits.startsWith("7")) {
        return `+7 ${digits.slice(1, 4)} ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
    }
    return phone;
};
export const formatLinkDateTime = (value) => value ? dayjs(value).format("DD.MM.YYYY HH:mm") : "—";
